import classNames from 'classnames';
import { ReactNode, useState } from 'react';
import { Edit, Eye } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { User } from '../../../Shared/types';
import { Button } from '../../../Shared/UI/Button';
import { Icon } from '../../../Shared/UI/Icon';
import Pill from '../../../Shared/UI/Pill';
import { CustomMailType, DonationFormMailType, ProjectMailType } from '../../types';
import MailTemplate, { MailTemplateProps } from './MailTemplate';

export interface MailEditorProps {
  type: ProjectMailType | CustomMailType | DonationFormMailType;
  editor: ReactNode;
  preview: string | null;
  charity: MailTemplateProps['charity'];
  project?: MailTemplateProps['project'];
  donationForm?: MailTemplateProps['donationForm'];
  headerUrl?: MailTemplateProps['headerUrl'];
  user: User;
  disabled?: boolean;
}

export default function MailEditor({
  type,
  editor,
  preview,
  charity,
  project,
  donationForm,
  headerUrl,
  user,
  disabled,
}: MailEditorProps) {
  const { t } = useTranslation();

  const [tab, setTab] = useState<'editor' | 'preview'>('editor');

  return (
    <div>
      {!disabled && (
        <Pill className="mb-2">
          <Button
            onClick={() => setTab('editor')}
            size="sm"
            variant="secondary"
            className={classNames('relative', tab === 'editor' ? '!bg-none !bg-slate-150 z-10' : undefined)}
          >
            <Icon className="mr-1.5">
              <Edit />
            </Icon>
            {t('backend:edit')}
          </Button>
          <Button
            onClick={() => setTab('preview')}
            size="sm"
            variant="secondary"
            className={classNames('relative', tab === 'preview' ? '!bg-none !bg-slate-150 z-10' : undefined)}
          >
            <Icon className="mr-1.5">
              <Eye />
            </Icon>
            {t('backend:preview')}
          </Button>
        </Pill>
      )}
      {tab === 'editor' && !disabled && editor}
      {(tab === 'preview' || disabled) && (
        <MailTemplate
          type={type}
          charity={charity}
          project={project}
          donationForm={donationForm}
          headerUrl={headerUrl}
          body={preview || ''}
          user={user}
        />
      )}
    </div>
  );
}

